import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { IconArrowLeft } from '@tabler/icons-react';

/** A 48 px "Back" link. Goes to `to`, or back in history. */
export function BackLink({ to, label = 'Back', onClick }: { to?: string; label?: string; onClick?: () => void }) {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      className="proc-backlink"
      onClick={() => (onClick ? onClick() : to ? navigate(to) : navigate(-1))}
    >
      <IconArrowLeft size={20} aria-hidden="true" /> {label}
    </button>
  );
}

/** Optional eyebrow + display title (h1) + lede: the top of every page. Steps use StepHeader. */
export function PageIntro({ eyebrow, title, lede }: { eyebrow?: ReactNode; title: ReactNode; lede?: ReactNode }) {
  return (
    <header>
      {eyebrow && <p className="proc-eyebrow">{eyebrow}</p>}
      <h1 className="proc-title">{title}</h1>
      {lede && <p className="proc-lede">{lede}</p>}
    </header>
  );
}

/** Section heading inside a page (an h2, so screen-reader users can jump between sections). */
export function SectionLabel({ children, hint, id }: { children: ReactNode; hint?: ReactNode; id?: string }) {
  return (
    <h2 className="proc-sectlabel" id={id}>
      {children}
      {hint && <> <span>· {hint}</span></>}
    </h2>
  );
}

/** One label / value row in a summary card. */
export function SummaryRow({ k, v, sub }: { k: ReactNode; v: ReactNode; sub?: ReactNode }) {
  return (
    <div className="proc-srow">
      <span className="k">{k}</span>
      <span className="v">
        {v}
        {sub && <small>{sub}</small>}
      </span>
    </div>
  );
}
